import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type AssetDomain } from '../../../../types/domain/asset-domain'
import { type AssetPersistence } from '../../../../types/persistence/asset-persistence'

const createAsset = async (data: AssetPersistence): Promise<AssetDomain> => {
  const response = await api.post('/assets', data)
  return response.data
}

export const useAssetCreateMutation = () => {
  return useMutation('create-asset', (asset: AssetPersistence) =>
    createAsset(asset)
  )
}
